import { Location } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { filter, share, switchMap, withLatestFrom } from 'rxjs/operators';
import { selectRouteParams } from 'src/app/app.selector';
import { Tag } from '../../app.models';
import { selectCustomerApiEndpoint } from '../../app.selector';
import { TestPushComponent } from '../test-push/test-push.component';

@Component({
  selector: 'app-tag-info',
  templateUrl: './tag-info.component.html',
  styleUrls: ['./tag-info.component.scss']
})
export class TagInfoComponent implements OnInit {
  endpoint: string;
  subscribers$: Observable<Object>;
  $context: Subscription;
  clientId: any;
  $tag: Subscription;
  tag: Tag;

  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    private title: Title,
    public location: Location
  ) { }

  ngOnInit(): void {
    // context (routing + endpoints)
    const context$ = this.store.select(selectCustomerApiEndpoint).pipe(
      filter((c) => !!c),
      withLatestFrom(this.store.select(selectRouteParams)),
    );

    //set context to component
    this.$context = context$.subscribe(([endpoint, params]) => {
      this.clientId = params.clientId;
      this.endpoint = endpoint;
    });

    // fetch tag with given url params as soon as endpoint is there (contract is choosed)
    this.$tag = context$.pipe(
      switchMap(([endpoint, params]) =>
        this.http.get(`${endpoint}/tags/${params['id']}`),
      ),
      share()
    ).subscribe(
      (tag: Tag) => {
        this.tag = tag
        this.title.setTitle('Info:' + tag.name);
      }, (e: HttpErrorResponse) =>
      this.router.navigate(['/404'], {
        state: { msg: "The tag doesn't exist." },
      }),
    )
  }

  testpush() {
    this.dialogService.open(TestPushComponent, {
      context: {
        contextTag: this.tag,
      },
    });
  }

  edit() {
    this.router.navigate(['..'], { relativeTo: this.route });
  }

  ngOnDestroy() {
    this.$context.unsubscribe();
    this.$tag.unsubscribe();
  }
}
